export const DefaultItemWidthDesktop = 340 + 30;
export const DefaultItemWidthMobile = 249 + 20;
export const MaxCarouselWidth = 1460;
export const MaxItems = 4;
